import { RouteRecordRaw } from 'vue-router';
import { defaultMetaQuestionnaire } from '../routesSetup';
import QuestionnaireVerifyIdentityView from '../../lib/pages/QuestionnaireVerifyIdentityView.vue';
import QuestionnaireFormView from '../../lib/pages/QuestionnaireFormView.vue';
import QuestionnaireSubmittedView from '../../lib/pages/QuestionnaireSubmittedView.vue';
import { formQuestionnaireIdentity } from '../../data/forms';

// Access: the questionnaire link plus full patient details — first name, last name, postcode
// and date of birth — or an authToken already bound to that patient.
// `form/:section` is the sectioned variant — a slug per FORM node, so back and
// refresh land somewhere meaningful.
const questionnaireChildren: RouteRecordRaw[] = [
  {
    path: 'verify-identity',
    name: 'questionnaire-verify-identity',
    component: QuestionnaireVerifyIdentityView,
    meta: {
      ...defaultMetaQuestionnaire,
      formConfig: formQuestionnaireIdentity,
      layoutPageTitle: 'Confirm your identity',
      pageTitle: 'Confirm your identity',
      backButton: false,
    },
  },
  {
    path: 'form',
    name: 'questionnaire-form',
    component: QuestionnaireFormView,
    meta: {
      ...defaultMetaQuestionnaire,
      layoutPageTitle: 'Your questionnaire',
      pageTitle: 'Your questionnaire',
    },
  },
  {
    path: 'form/:section',
    name: 'questionnaire-form-section',
    component: QuestionnaireFormView,
    meta: {
      ...defaultMetaQuestionnaire,
      layoutPageTitle: 'Your questionnaire',
      pageTitle: 'Your questionnaire',
    },
  },
  {
    path: 'submitted-successfully',
    name: 'questionnaire-submitted-successfully',
    component: QuestionnaireSubmittedView,
    meta: {
      ...defaultMetaQuestionnaire,
      layoutPageTitle: null,
      pageTitle: 'Questionnaire submitted',
      panelTitle: 'Questionnaire submitted',
      backButton: false,
    },
  },
];

export default questionnaireChildren;
